/*
 * @Description: static routes
 */

//! If unnecessary, please don't set name in root, otherwise it will be shown in breadcrumb.
// import aboutSvg from '@/assets/icons/Upload.svg?inline';
const routes = [
    {
        root: {},
        meta: { alive: true },
        path: '/',
        hidden: false,
        redirect: '/BestYou/about',
        component: 'ProLayout',
        permissions: [],
        children: [
            {
                name: 'home',
                meta: {
                    // icon: require('../assets/icons/Upload.svg'),
                    module: 'System',
                    function: 'Home Page'
                },
                path: '/home',
                hidden: false,
                component: 'home/index.vue',
                permissions: []
            },
            {
                name: 'bestyou',
                meta: { icon: require('../assets/icons/Upload.svg'), alive: true },
                path: '/BestYou',
                hidden: false,
                redirect: '/BestYou/nomination',
                component: 'RouteView',
                permissions: ['nomination.individual','nomination.team','nomination.eyes'],
                children: [
                    {
                        name: 'about',
                        meta: { icon: require('../assets/icons/Upload.svg'), alive: true },
                        path: '/BestYou/about',
                        hidden: false,
                        component: 'BestYou/about/index.vue',
                        permissions: ['nomination.eyes']
                    },
                    {
                        name: 'nomination',
                        meta: { icon: require('../assets/icons/Contract.svg'), alive: true },
                        path: '/BestYou/nomination',
                        hidden: false,
                        redirect: '/BestYou/nomination/nomination',
                        component: 'RouteView',
                        permissions: ['nomination.individual','nomination.team','nomination.eyes'],
                        children: [
                            {
                                name: 'nomination',
                                meta: { module: 'BestYou', function: 'BestYou' },
                                path: '/BestYou/nomination/nomination',
                                hidden: false,
                                component: 'BestYou/nomination/nomination/index',
                                permissions: ['nomination.eyes']
                            },
                            {
                                name: 'nomination.eyes',
                                meta: { module: 'BestYou', function: 'BestYou' },
                                path: '/BestYou/nomination/eyes',
                                hidden: false,
                                component: 'BestYou/nomination/eyes/index',
                                permissions: ['nomination.eyes']
                            },
                            {
                                name: 'nomination.individual',
                                meta: { module: 'BestYou', function: 'BestYou' },
                                path: '/BestYou/nomination/individual',
                                hidden: false,
                                component: 'BestYou/nomination/individual/index',
                                permissions: ['nomination.individual']
                            },
                            {
                                name: 'nomination.individual',
                                meta: { module: 'BestYou', function: 'BestYou' },
                                path: '/BestYou/nomination/individual',
                                hidden: true,
                                component: 'BestYou/nomination/individual/index',
                                permissions: []
                            },
                            {
                                name: 'nomination.team',
                                meta: { module: 'BestYou', function: 'BestYou' },
                                path: '/BestYou/nomination/team',
                                hidden: false,
                                component: 'BestYou/nomination/team/index',
                                permissions: ['nomination.team']
                            },
                            {
                                name: 'nomination.team',
                                meta: { module: 'BestYou', function: 'BestYou' },
                                path: '/BestYou/nomination/team',
                                hidden: true,
                                component: 'BestYou/nomination/team/index',
                                permissions: []
                            },
                            {
                                name: 'nomination.history',
                                meta: { module: 'BestYou', function: 'BestYou' },
                                path: '/BestYou/nomination/history',
                                hidden: false,
                                component: 'BestYou/nomination/history/index',
                                permissions: ['nomination.eyes']
                            }
                        ]
                    },

                    {
                        name: 'approve',
                        meta: { icon: require('../assets/icons/approve.svg'), alive: true },
                        path: '/BestYou',
                        hidden: false,
                        redirect: '/BestYou/approve/approve',
                        component: 'RouteView',
                        permissions: ['online_budget_report.query', 'online_report.query','approval_report.query'],
                        children: [
                            {
                                name: 'approve',
                                meta: { module: 'BestYou', function: 'BestYou',hidden: true},
                                path: '/BestYou/approve/approve',
                                redirect: '/BestYou/approve/index',
                                component: 'RouteView',
                                permissions: ['approval_report.query', 'online_budget_report.query'],
                                children: [
                                    {
                                        hidden: true,
                                        name: 'approve',
                                        meta: { module: 'BestYou', function: 'BestYou' },
                                        path: '/BestYou/approve/index',
                                        component: 'BestYou/approve/index/index',
                                        permissions: ['approval_report.query','online_budget_report.query']
                                    },
                                    {
                                        name: 'approve',
                                        meta: { module: 'BestYou', function: 'BestYou' },
                                        path: '/BestYou/approve/budget',
                                        hidden: true,
                                        component: 'BestYou/approve/budget/index',
                                        permissions: ['online_budget_report.query']
                                    },
                                    {
                                        name: 'approve',
                                        meta: { module: 'BestYou', function: 'BestYou' },
                                        path: '/BestYou/approve/approval',
                                        hidden: true,
                                        component: 'BestYou/approve/approval/index',
                                        permissions: ['approval_report.query']
                                    }
                                ]
                            },
                            {
                                name: 'approve.report',
                                meta: { module: 'BestYou', function: 'BestYou' },
                                path: '/BestYou/approve',
                                redirect: '/BestYou/approve/report',
                                component: 'RouteView',
                                permissions: ['online_report.query'],
                                children: [
                                    {
                                        hidden: true,
                                        name: 'approve.report',
                                        meta: { module: 'BestYou', function: 'BestYou',hidden: true },
                                        path: '/BestYou/approve/report',
                                        component: 'BestYou/approve/report/index',
                                        permissions: ['online_report.query']
                                    }
                                ]
                            }
                        ]
                    },


                    // {
                    //     name: 'approve',
                    //     meta: { icon: require('../assets/icons/approve.svg'), alive: true },
                    //     path: '/BestYou/approve',
                    //     hidden: false,
                    //     redirect: '/BestYou/approve/report',
                    //     component: 'RouteView',
                    //     permissions: ['location_maintenance.query', 'record.query','approval_report.query'],
                    //     children: [
                    //         {
                    //             name: 'approve',
                    //             meta: { module: 'BestYou', function: 'BestYou' },
                    //             path: '/BestYou/approve/index',
                    //             hidden: false,
                    //             component: 'BestYou/approve/index/index',
                    //             permissions: ['approval_report.query']
                    //         },
                    //         {
                    //             name: 'approve',
                    //             meta: { module: 'BestYou', function: 'BestYou' },
                    //             path: '/BestYou/approve/budget',
                    //             hidden: true,
                    //             component: 'BestYou/approve/budget/index',
                    //             permissions: ['approval_report.query']
                    //         },
                    //         {
                    //             name: 'approve',
                    //             meta: { module: 'BestYou', function: 'BestYou' },
                    //             path: '/BestYou/approve/approval',
                    //             hidden: true,
                    //             component: 'BestYou/approve/approval/index',
                    //             permissions: ['approval_report.query']
                    //         },
                    //         {
                    //             name: 'approve.report',
                    //             meta: { module: 'BestYou', function: 'BestYou' },
                    //             path: '/BestYou/approve/report',
                    //             hidden: false,
                    //             component: 'BestYou/approve/report/index',
                    //             permissions: ['location_maintenance.query']
                    //         }
                    //     ]
                    // },
                    {
                        name: 'support',
                        meta: { icon: require('../assets/icons/support.svg'), alive: true },
                        path: '/BestYou/support',
                        hidden: false,
                        redirect: '/BestYou/support/pickUpLocation',
                        component: 'RouteView',
                        permissions: ['hrbp_maintenance.query', 'cancel.query','budget_maintenance.query', 'pickup_location.query','pickup_record.query','pickup_date.query','download_congratulation_template.query'],
                        children: [
                            {
                                name: 'support.budget',
                                meta: { module: 'BestYou', function: 'BestYou' },
                                path: '/BestYou/support/budgetMaintenance',
                                hidden: false,
                                component: 'BestYou/support/budgetMaintenance/index',
                                permissions: ['budget_maintenance.query']
                            },
                            // {
                            //     name: 'support.maintenance',
                            //     meta: { module: 'BestYou', function: 'BestYou' },
                            //     path: '/BestYou/support/maintenance',
                            //     hidden: false,
                            //     component: 'BestYou/support/maintenance/index',
                            //     permissions: ['hrbp_maintenance.query']
                            // },
                            {
                                name: 'support.congratulationTemplate',
                                meta: { module: 'BestYou', function: 'BestYou' },
                                path: '/BestYou/support/congratulationTemplate',
                                hidden: false,
                                component: 'BestYou/support/congratulationTemplate/index',
                                permissions: ['download_congratulation_template.query']
                            },
                            {
                                name: 'support.pickUpLocation',
                                meta: { module: 'BestYou', function: 'BestYou' },
                                path: '/BestYou/support/pickUpLocation',
                                hidden: false,
                                component: 'BestYou/support/pickUpLocation/index',
                                permissions: ['pickup_location.query']
                            },
                            {
                                name: 'support.pickUpDate',
                                meta: { module: 'BestYou', function: 'BestYou' },
                                path: '/BestYou/support/pickUpDate',
                                hidden: false,
                                component: 'BestYou/support/pickUpDate/index',
                                permissions: ['pickup_date.query']
                            },
                            {
                                name: 'support.pickUpRecord',
                                meta: { module: 'BestYou', function: 'BestYou' },
                                path: '/BestYou/support/pickUpRecord',
                                hidden: false,
                                component: 'BestYou/support/pickUpRecord/index',
                                permissions: ['pickup_record.query']
                            },
                            {
                                name: 'support.cancellation',
                                meta: { module: 'BestYou', function: 'BestYou' },
                                path: '/BestYou/support/cancellation',
                                hidden: false,
                                component: 'BestYou/support/cancellation',
                                permissions: ['cancel.query']
                            },
                            {
                                name: 'support.NDelegation',
                                meta: { module: 'BestYou', function: 'BestYou' },
                                path: '/BestYou/support/NDelegation',
                                hidden: false,
                                component: 'BestYou/support/NDelegation/index',
                                permissions: ['delegation.query']
                            }
                        ]
                    },
                    {
                        name: 'winner',
                        meta: { icon: require('../assets/icons/winner.svg'), alive: true },
                        path: '/BestYou/winner',
                        hidden: false,
                        component: 'BestYou/winner/index.vue',
                        permissions: ['nomination.eyes']
                    },
                    {
                        name: 'rbac',
                        meta: { icon: { type: 'user', theme: 'outlined' }, alive: true },
                        path: '/system/rbac',
                        hidden: false,
                        redirect: '/system/rbac/user-list',
                        component: 'RouteView',
                        permissions: ['permission.query', 'role.query', 'user.query'],
                        children: [
                            {
                                name: 'rbac.user',
                                meta: { module: 'System', function: 'User Management' },
                                path: '/system/rbac/user-list',
                                hidden: false,
                                component: 'system/rbac/user/UserList.vue',
                                permissions: ['user.query']
                            },
                            {
                                name: 'rbac.role',
                                meta: { module: 'System', function: 'Role Management' },
                                path: '/system/rbac/role-list',
                                hidden: false,
                                component: 'system/rbac/role/RoleList.vue',
                                permissions: ['role.query']
                            },
                            {
                                name: 'rbac.permission',
                                meta: { module: 'System', function: 'Permission Management' },
                                path: '/system/rbac/permission-list',
                                hidden: false,
                                component: 'system/rbac/permission/PermissionList.vue',
                                permissions: ['permission.query']
                            },
                            {
                                name: 'rbac.email',
                                meta: { module: 'System', function: 'Permission Management' },
                                path: '/system/rbac/email-list',
                                hidden: false,
                                component: 'system/rbac/email/email.vue',
                                permissions: ['permission.query']
                            }
                        ]
                    },
                    {
                        name: 'system.notification',
                        meta: {
                            icon: { type: 'setting', theme: 'outlined' },
                            module: 'System',
                            function: 'Notification Management'
                        },
                        path: '/system/notification',
                        hidden: false,
                        component: 'system/notification/index.vue',
                        permissions: ['notification.query']
                    },
                    {
                        name: 'system.dictionary',
                        meta: { icon: { type: 'menu', theme: 'outlined' } },
                        path: '/system/dict',
                        hidden: false,
                        component: 'system/dict/DictList.vue',
                        permissions: ['dict.query']
                    },
                    {
                        name: 'audit',
                        meta: { icon: { type: 'audit', theme: 'outlined' } },
                        path: '/system/audit',
                        hidden: false,
                        component: 'system/audit/AuditList.vue',
                        permissions: ['audit.query']
                    }
                    // {
                    //     name: 'delegation',
                    //     meta: { isKeepAlive: true, icon: { type: 'team', theme: 'outlined' } },
                    //     path: '/system/delegation',
                    //     hidden: false,
                    //     component: 'system/delegation/DelegationList.vue',
                    //     permissions: ['delegation.query']
                    // }
                ]
            },
            {
                name: 'notFound',
                meta: { icon: {} },
                path: '/404',
                hidden: true,
                component: 'NotFound',
                permissions: []
            }
        ]
    }
];
export default routes;
